const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getAllAnchors = async () => {
  try {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${BASE_URL}/eci/apis/v4/anchors/getall_anchors`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });

    if (!response.ok) {
      throw new Error("Failed to fetch anchors");
    }

    const data = await response.json();
    return data.msg || [];
  } catch (error) {
    console.error("Error fetching anchors:", error);
    throw error;
  }
};

export const getAnchorSubscriptions = async (walletId) => {
  try {
    const token = localStorage.getItem('authToken');
    const response = await fetch(
      `${BASE_URL}/eci/apis/v4/wallets/${walletId}/anchor_subscriptions`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch anchor subscriptions");
    }

    const data = await response.json();
    return data.msg?.items || [];
  } catch (error) {
    console.error("Error fetching anchor subscriptions:", error);
    throw error;
  }
};